module.exports = __webpack_public_path__ + "8e9f805264356473c46d946445115ae5.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Balzano.eot?v=1.00
// module id = 933
// module chunks = 24